import { useLanguageContext } from '@/pages/languages/useLanguageContext';
import { Loading } from '@startupquickstart/frontend';
import { formatDate } from '@startupquickstart/frontend';

export function LanguageOverviewTab() {
  const { language, isLoading } = useLanguageContext();

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <Loading />
      </div>
    );
  }

  if (!language) return null;

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
        {/* Left column */}
        <div className="lg:col-span-3 space-y-6">
          <div className="rounded-xl border bg-card shadow-sm">
            <div className="px-6 py-4 border-b">
              <h2 className="text-lg font-medium tracking-tight text-zinc-900">About</h2>
              <p className="text-sm text-muted-foreground">
                Language configuration and details
              </p>
            </div>
            <div className="p-6 space-y-4">
              <div>
                <div className="text-xs font-medium uppercase tracking-wider text-muted-foreground mb-0.5">
                  Language Code
                </div>
                <div className="text-sm font-mono">{language.code}</div>
              </div>
              {language.isDefault && (
                <div>
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-primary/10 text-primary">
                    Default Language
                  </span>
                </div>
              )}
            </div>
            <div className="border-t px-6 py-4 text-sm text-muted-foreground flex flex-wrap gap-x-6 gap-y-1">
              <span>Created: {formatDate(language.createdAt)}</span>
              <span>Updated: {formatDate(language.updatedAt)}</span>
            </div>
          </div>
        </div>

        {/* Right column */}
        <div className="lg:col-span-2 space-y-6">
          <div className="rounded-xl border bg-card shadow-sm">
            <div className="px-6 py-4 border-b">
              <h2 className="text-lg font-medium tracking-tight text-zinc-900">Details</h2>
              <p className="text-sm text-muted-foreground">Language information</p>
            </div>
            <div className="p-6">
              <div className="divide-y">
                <div className="py-3 first:pt-0">
                  <div className="text-xs font-medium uppercase tracking-wider text-muted-foreground mb-0.5">
                    Name
                  </div>
                  <div className="text-sm">{language.name}</div>
                </div>
                <div className="py-3">
                  <div className="text-xs font-medium uppercase tracking-wider text-muted-foreground mb-0.5">
                    Code
                  </div>
                  <div className="text-sm font-mono">{language.code}</div>
                </div>
                <div className="py-3">
                  <div className="text-xs font-medium uppercase tracking-wider text-muted-foreground mb-0.5">
                    Default
                  </div>
                  <div className="text-sm">{language.isDefault ? 'Yes' : 'No'}</div>
                </div>
                <div className="py-3">
                  <div className="text-xs font-medium uppercase tracking-wider text-muted-foreground mb-0.5">
                    ID
                  </div>
                  <div className="text-sm font-mono text-muted-foreground">{language.id}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
